/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum DisciplineGroupTypeEnum {
    DisciplineGroup = 'DisciplineGroup',
    PackGroup = 'PackGroup'
}

export function DisciplineGroupTypeEnumFromJSON(json: any): DisciplineGroupTypeEnum {
    return DisciplineGroupTypeEnumFromJSONTyped(json, false);
}

export function DisciplineGroupTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisciplineGroupTypeEnum {
    return json as DisciplineGroupTypeEnum;
}

export function DisciplineGroupTypeEnumToJSON(value?: DisciplineGroupTypeEnum | null): any {
    return value as any;
}

